export const PRIVATE_POLICY = {
  URL: '/private_policy',
  TITLE: 'Политика конфиденциальности'
}


// WEBPACK FOOTER //
// ./src/features/ProvatePolicy/links.js